// Per-user recently opened projects / customers (device-local)
const key = (u) => `ali_recent:${u || "anon"}`;
const MAX = 8;

export function getRecent(username) {
  try { return JSON.parse(localStorage.getItem(key(username))) || []; } catch { return []; }
}

export function pushRecent(username, item) {
  if (!item?.id || !item?.type) return;
  const list = getRecent(username).filter((r) => !(r.type === item.type && r.id === item.id));
  list.unshift({ ...item, ts: Date.now() });
  try { localStorage.setItem(key(username), JSON.stringify(list.slice(0, MAX))); } catch {}
  window.dispatchEvent(new CustomEvent("ali-recent"));
}

export function clearRecent(username) {
  try { localStorage.removeItem(key(username)); } catch {}
  window.dispatchEvent(new CustomEvent("ali-recent"));
}

// Last 5 ⌘K queries per user
const qkey = (u) => `ali_qhist:${u || "anon"}`;
export function getQueryHistory(username) {
  try { return JSON.parse(localStorage.getItem(qkey(username))) || []; } catch { return []; }
}
export function pushQuery(username, q) {
  const v = String(q || "").trim();
  if (v.length < 2) return;
  const list = [v, ...getQueryHistory(username).filter((x) => x.toLowerCase() !== v.toLowerCase())].slice(0, 5);
  try { localStorage.setItem(qkey(username), JSON.stringify(list)); } catch {}
  window.dispatchEvent(new CustomEvent("ali-recent"));
}
export function removeQuery(username, q) {
  const list = getQueryHistory(username).filter((x) => x !== q);
  try { localStorage.setItem(qkey(username), JSON.stringify(list)); } catch {}
  window.dispatchEvent(new CustomEvent("ali-recent"));
}
